module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA5.2f25f3a3.jpg";